/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Offset_TimecodeInputs */

const en_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset the timecode of the selected event(s) based on the playhead position`)
};

const fr_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler le timecode des evenements selectionnes selon la position de la tete de lecture`)
};

const de_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschieben Sie den Timecode des/der ausgewählten Ereignisse(s) basierend auf der Abspielkopfposition.`)
};

const it_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta il codice temporale degli eventi selezionati in base alla posizione della testina di riproduzione`)
};

const ru_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сместите временной код выбранного события (событий) в соответствии с положением ползунка воспроизведения.`)
};

const es_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar el código de tiempo de los eventos seleccionados en función de la posición del cabezal de reproducción`)
};

const zh_cn2_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据播放头位置偏移所选事件的时间码`)
};

const ja_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生ヘッドの位置に基づいて、選択したイベントのタイムコードをオフセットします。`)
};

const hi_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेहेड की स्थिति के आधार पर चयनित इवेंट के टाइमकोड को ऑफसेट करें।`)
};

const pt_pt2_shortcut_keys_desc_offset_timecode = /** @type {(inputs: Shortcut_Keys_Desc_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste o código de tempo do(s) evento(s) selecionado(s) com base na posição do indicador de reprodução.`)
};

/**
* | output |
* | --- |
* | "Offset the timecode of the selected event(s) based on the playhead position" |
*
* @param {Shortcut_Keys_Desc_Offset_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_offset_timecode = /** @type {((inputs?: Shortcut_Keys_Desc_Offset_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Offset_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "de") return de_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "it") return it_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "es") return es_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_offset_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_offset_timecode(inputs)
	return en_shortcut_keys_desc_offset_timecode(inputs)
});